import React, { useState } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { FaAngleRight, FaHome, FaSearch } from "react-icons/fa";
import defaultImg from "../../images/defaultImg.png"
export default function SearchResults() {
    const [menuClick, setMenuClick] = useState(false)
    const toggleMenu = () => {
        setMenuClick(!menuClick)
    }
    const closeMenu = () => {
        setMenuClick(false)
    }
    return (
        <>
            <div className="main-wrapper">
                <div className="top-color"></div>
                <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
                <div className="content-wrapper">
                    <Header Header="Search Results" toggleMenu={toggleMenu} menuClick={menuClick} />
                    <div className="main-container">
                        <div className="card main-card">
                            <div className="card-body">
                                <div className="row py-3">
                                    <div className="col-md-5 mx-auto">
                                        <div className="xiliFilters">
                                            <h1 className="sub-head py-0 d-flex aling-items-center flex-wrap">All Filters <span className="ms-auto text-capitalize">Applied (1)</span></h1>
                                            <h4 className="schedule-td-head">Department</h4>
                                            <div className="form-group">
                                                <input type="checkbox" id="html" className="me-1" />
                                                <label for="html">Marketing business & Sales</label>
                                                <span>(1042)</span>
                                            </div>
                                            <div className="form-group">
                                                <input type="checkbox" id="html1" className="me-1" />
                                                <label for="html1">Marketing business & Sales</label>
                                                <span>(1042)</span>
                                            </div>
                                            <div className="form-group mb-0">
                                                <input type="checkbox" id="html2" className="me-1" />
                                                <label for="html2">Marketing business & Sales</label>
                                                <span>(1042)</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}